import React, { useState, useEffect } from 'react';
import { ChevronLeft, X } from 'lucide-react';
import styles from '../styles/components/_FoodModalContent.module.scss';

const FoodModalContent = ({ food, onClose }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = (e) => {
    e.stopPropagation();
    if (typeof onClose === 'function') {
      onClose();
    } else {
      console.warn('onClose is not a function');
    }
  };

  const renderContent = () => {
    if (isLoading) {
      return (
        <div className={styles.loadingContainer}>
          <div className={styles.loadingSpinner}></div>
          <p>Chargement...</p>
        </div>
      );
    }

    if (error) {
      return (
        <div className={styles.errorContainer}>
          <p>Une erreur est survenue lors du chargement du contenu.</p>
        </div>
      );
    }

    const content = food.acf?.menu?.url;

    if (!content) {
      return (
        <div className={styles.noContent}>
          <p>Menu non disponible</p>
        </div>
      );
    }

    // Vérifier si le contenu est une URL d'image
    const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(content);
    // Vérifier si le contenu est une URL de PDF
    const isPDF = /\.pdf$/i.test(content);

    if (isImage) {
      return (
        <div className={styles.imageContainer}>
          <img 
            src={content} 
            alt={`Menu de ${food.title}`}
            className={styles.contentImage}
            onError={() => setError(true)}
          />
        </div>
      );
    }

    if (isPDF) {
      return (
        <div className={styles.pdfContainer}>
          <iframe
            src={`${content}#toolbar=0`}
            title={`Menu de ${food.title}`}
            className={styles.pdfViewer}
            onError={() => setError(true)}
          />
        </div>
      );
    }

    return (
      <div className={styles.textContent}>
        <p>{content}</p>
      </div>
    );
  };

  if (!food || !food.acf) return null;

  return (
    <div className={styles.container}>
      <header 
        className={styles.header}
        style={{
          backgroundImage: `url(${food.acf?.image?.url})`
        }}
      >
        {isDesktop ? (
          <button 
            className={styles.desktopCloseButton} 
            onClick={handleClose}
            type="button"
            aria-label="Fermer le menu"
          >
            <X size={24} />
          </button>
        ) : (
          <button 
            className={styles.closeButton} 
            onClick={handleClose}
            type="button"
            aria-label="Retour"
          >
            <ChevronLeft size={24} />
          </button>
        )}
        <div className={styles.brandInfo}>
          <div className={styles.logoWrapper}>
            <img
              src={food.acf?.logo?.url}
              alt={food.title}
              className={styles.logo}
            />
          </div>
          <h2 className={styles.title}>{food.title}</h2>
        </div>
      </header>

      <div className={styles.menuContent}>
        {renderContent()}
      </div>
    </div>
  );
};

export default FoodModalContent;